import { TechnicalCategory, TechnicalCategoryBookmark } from '@services';

export const TechnicalCategories = [
  'Adjustments',
  'Maintenance',
  'Procedures',
  'Lubricants',
  'Drawings',
  'Tyres',
];

export type TechnicalCategoryType =
  | 'Adjustments'
  | 'Maintenance'
  | 'Procedures'
  | 'Lubricants'
  | 'Drawings'
  | 'Tyres';

export interface ITechnicalCategoryHook {
  categories: TechnicalCategory[];
  totalCount: number;
  name: string;
  setName: (name: string) => void;
  handleNameSearch: (name: string) => void;
}

export interface ITechnicalCategoryBookmarkHook {
  bookmarks: TechnicalCategoryBookmark[];
  totalCount: number;
}
